import { FunctionComponent } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { managementTouchIconButtonSx } from "../utils/management-touch-target.styles";
import { ManagementPrintButton } from "./ManagementPrintButton";

type ManagementDetailPageHeaderProps = {
  title: string;
  testId?: string;
  onPrint?: () => void;
};

/**
 * Shared back-to-Management header for linked-report detail pages.
 */
export const ManagementDetailPageHeader: FunctionComponent<ManagementDetailPageHeaderProps> = ({
  title,
  testId,
  onPrint
}) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      sx={{ mb: 2 }}
      data-testid={testId}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
        <IconButton
          component={RouterLink}
          to="/management"
          aria-label={t("_management_backToManagement")}
          data-testid="management-detail-back"
          sx={managementTouchIconButtonSx}
        >
          <ArrowBack fontSize="small" />
        </IconButton>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      </Stack>
      {onPrint ? <ManagementPrintButton onPrint={onPrint} /> : null}
    </Stack>
  );
};
